export default {"src":"/_next/static/media/protection.26ed831f.svg","height":33,"width":32,"blurWidth":0,"blurHeight":0};